import React from 'react';
export function SectionDivider() {
  return <div className="w-full max-w-4xl mx-auto py-8 md:py-12 px-4" data-id="element-423">
      <div className="h-px w-full bg-gradient-to-r from-transparent via-amber/50 to-transparent opacity-50" data-id="element-424" />
    </div>;
}